import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AboutPage } from './components/AboutPage';
import { Header } from './components/Header';
import { EarlyWarningReport } from './components/EarlyWarningReport';
import { ContactPage } from './components/ContactPage';
import { FAQsPage } from './components/FAQsPage';
import { TimelinePage } from './components/TimelinePage';
import { SEO } from './components/SEO';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <div className="min-h-screen bg-gradient-to-br from-secondary-50 via-white to-primary-50/20 font-sans" data-id="element-3">
        <SEO data-id="element-4" />
        <Header data-id="element-5" />
        <main className="container mx-auto px-4 py-12" data-id="element-6">
          <Routes data-id="element-7">
            <Route path="/" element={<EarlyWarningReport data-id="element-9" />} data-id="element-8" />
            <Route path="/timeline" element={<TimelinePage data-id="element-11" />} data-id="element-10" />
            <Route path="/faqs" element={<FAQsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/about" element={<AboutPage data-id="element-15" />} data-id="element-14" />
            <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <footer className="bg-gradient-to-r from-secondary-900 to-secondary-800 text-white py-10 mt-20 relative overflow-hidden" data-id="element-18">
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-19"></div>
          <div className="container mx-auto px-4 text-center relative z-10" data-id="element-20">
            <p className="text-lg" data-id="element-21">
              © Early Warning Report. All Rights Reserved.
            </p>
          </div>
        </footer>
      </div>
    </BrowserRouter>;
}